import { Skeleton } from "@/components/ui/skeleton";

export function FornecedorCardSkeleton() {
  return (
    <div className="bg-white p-5 border border-[#E5E7EB] rounded-[16px] shadow-sm space-y-4 animate-pulse h-[320px]">
      <div className="flex justify-between items-start">
        <div className="w-14 h-14 rounded-2xl bg-gray-100 flex items-center justify-center">
          <Skeleton className="w-10 h-10 rounded-full bg-gray-200" />
        </div>
        <Skeleton className="w-6 h-6 rounded-full bg-gray-100" />
      </div>
      
      <div className="space-y-3">
        <Skeleton className="h-6 w-3/4 bg-gray-100 rounded-md" />
        
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-5 w-20 rounded-full bg-[#F7F9F5]" />
          <Skeleton className="h-5 w-24 rounded-full bg-[#F7F9F5]" />
        </div>
        
        <div className="space-y-2 pt-1">
          <div className="flex items-center gap-2">
            <Skeleton className="w-4 h-4 bg-gray-100" />
            <Skeleton className="h-4 w-32 bg-gray-100" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="w-4 h-4 bg-gray-100" />
            <Skeleton className="h-4 w-24 bg-gray-100" />
          </div>
        </div>
      </div>
      
      <Skeleton className="h-12 w-full rounded-xl bg-gray-200 mt-2" />
    </div>
  );
}

export function SkeletonPagina() {
  return (
    <div className="flex flex-col items-center justify-center p-4 bg-transparent min-h-[60vh]">
      <div className="w-full max-w-md space-y-4">
        <Skeleton className="h-12 w-12 rounded-full mx-auto" />
        <Skeleton className="h-8 w-3/4 mx-auto" />
        <Skeleton className="h-4 w-1/2 mx-auto" />
        <div className="space-y-2 pt-4">
          <Skeleton className="h-20 w-full rounded-2xl" />
          <Skeleton className="h-20 w-full rounded-2xl" />
        </div>
      </div>
    </div>
  );
}

export function FornecedorPerfilSkeleton() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl space-y-8 animate-pulse">
      <div className="bg-white p-8 rounded-[16px] border border-[#E5E7EB] shadow-sm h-[200px]">
        <div className="flex flex-col md:flex-row gap-8 items-start md:items-center">
          <div className="w-32 h-32 rounded-[24px] bg-gray-100 shrink-0 flex items-center justify-center">
            <Skeleton className="w-20 h-20 rounded-full bg-gray-200" />
          </div>
          <div className="flex-1 space-y-4 w-full">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div className="space-y-2">
                <Skeleton className="h-10 w-64 bg-gray-100 rounded-lg" />
                <div className="flex gap-3">
                  <Skeleton className="h-6 w-24 rounded-full bg-gray-100" />
                  <Skeleton className="h-6 w-32 rounded-full bg-gray-100" />
                </div>
              </div>
              <div className="flex gap-3">
                <Skeleton className="h-12 w-12 rounded-full bg-gray-100" />
                <Skeleton className="h-12 w-12 rounded-full bg-gray-100" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Skeleton className="h-20 rounded-[16px] bg-white border border-[#E5E7EB]" />
            <Skeleton className="h-20 rounded-[16px] bg-white border border-[#E5E7EB]" />
            <Skeleton className="h-20 rounded-[16px] bg-white border border-[#E5E7EB]" />
            <Skeleton className="h-20 rounded-[16px] bg-white border border-[#E5E7EB]" />
          </div>

          <div className="bg-white rounded-[16px] p-8 border border-[#E5E7EB] space-y-6 shadow-sm h-[300px]">
            <Skeleton className="h-8 w-48 bg-gray-100 rounded-md" />
            <div className="space-y-4">
              <Skeleton className="h-4 w-full bg-gray-50 rounded-sm" />
              <Skeleton className="h-4 w-full bg-gray-50 rounded-sm" />
              <Skeleton className="h-4 w-5/6 bg-gray-50 rounded-sm" />
              <Skeleton className="h-4 w-4/6 bg-gray-50 rounded-sm" />
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-[#0C1A12] p-8 rounded-[16px] shadow-sm space-y-6 h-[250px]">
            <Skeleton className="h-6 w-3/4 bg-white/10 rounded-md" />
            <div className="space-y-4">
              <Skeleton className="h-14 w-full rounded-xl bg-white/5" />
              <Skeleton className="h-14 w-full rounded-xl bg-white/5" />
            </div>
            <Skeleton className="h-12 w-full rounded-xl bg-[#C6F764]/20" />
          </div>
          
          <div className="bg-white p-6 rounded-[16px] border border-[#E5E7EB] shadow-sm space-y-4 h-[150px]">
            <Skeleton className="h-6 w-1/2 bg-gray-100 rounded-md" />
            <div className="flex gap-2 flex-wrap">
              <Skeleton className="h-8 w-20 rounded-full bg-gray-50" />
              <Skeleton className="h-8 w-24 rounded-full bg-gray-50" />
              <Skeleton className="h-8 w-16 rounded-full bg-gray-100" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
